module.exports = __webpack_public_path__ + "img/service1-03.a4e6cb2c.png";